<div class="crews-settings-container">
  <div class="crews-settings-content">
    <div class="crews-settings-header flex justify-between items-center">
      <div class="crews-settings-title flex flex-row items-center">
        <img src="/assets/icons/users.svg" alt="Users" />
        <div class="title">Crews</div>
      </div>
      <div>
        <a *ngIf="isAdmin" saAutomatedSelector="user-group__add-button" (click)="startAddCrew()" class="button-add"
          >Add</a
        >
      </div>
    </div>
    <div>
      <div class="grid grid-cols-2 crew-header" [class.grid-cols-3]="isAdmin">
        <div class="crew-header-title">
          Name
        </div>
        <div class="crew-header-title">
          Leader(s)
        </div>
        <div *ngIf="isAdmin" class="text-right crew-header-title"></div>
      </div>
      <div *ngFor="let groupCrew of crews$ | async">
        <div class="grid grid-cols-2 crew-row" [class.grid-cols-3]="isAdmin" *ngFor="let crew of groupCrew.crews">
          <div class="flex flex-col justify-center crew-row-content">
            {{ crew.name }}
          </div>
          <div class="flex flex-wrap crew-row-content">
            <mat-chip-list *ngFor="let leader of crew.leaders">
              <mat-chip>{{ leader.name }}</mat-chip>
            </mat-chip-list>
          </div>
          <div *ngIf="isAdmin" class="flex flex-col justify-center crew-row-content">
            <div class="text-right">
              <button mat-icon-button (click)="startEditCrew(crew)">
                <mat-icon>edit</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #addCrewModal>
  <div mat-dialog-title>
    Add Crew
  </div>
  <div>
    <form [formGroup]="addCrewForm" class="flex flex-col gap-2" (ngSubmit)="doAddCrew()">
      <div class="flex flex-col">
        <div class="form-field-label">
          Crew Name
        </div>
        <mat-form-field appearance="outline">
          <input matInput formControlName="name" />
          <mat-error *ngIf="addCrewForm.get('name').hasError('required')">
            Crew name is required
          </mat-error>
        </mat-form-field>
      </div>
      <div class="flex flex-col">
        <div class="form-field-label">
          Leader
        </div>
        <mat-form-field appearance="outline">
          <mat-select formControlName="leader">
            <mat-option>
              <ngx-mat-select-search
                placeholderLabel="User"
                noEntriesFoundLabel="User not found"
                [formControl]="leaderSearch"
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let user of possibleLeaders$ | async" [value]="user.id">{{ user.name }}</mat-option>
          </mat-select>
          <mat-error *ngIf="addCrewForm.get('leader').hasError('required')">
            Leader is required
          </mat-error>
        </mat-form-field>
      </div>
      <button type="submit" mat-raised-button color="primary">Add</button>
    </form>
  </div>
</ng-template>

<ng-template #updateCrewModal>
  <div mat-dialog-title>Update {{ (selectedCrew$$ | async).name }}</div>
  <div>
    <form [formGroup]="editCrewForm" class="flex flex-col gap-2" (ngSubmit)="doEditCrew()">
      <div class="flex flex-col">
        <div class="form-field-label">
          Crew Name
        </div>
        <mat-form-field appearance="outline">
          <input matInput formControlName="name" />
          <mat-error *ngIf="editCrewForm.get('name').hasError('required')">
            Crew name is required
          </mat-error>
        </mat-form-field>
      </div>
      <button type="submit" mat-raised-button color="primary">Update Name</button>
    </form>
    <div class="my-3 text-xl">Leaders</div>
    <div *ngFor="let leader of (selectedCrew$$ | async).leaders" class="flex justify-between items-center">
      <div>
        {{ leader.name }}
      </div>
      <div *ngIf="(selectedCrew$$ | async).leaders.length > 1">
        <button mat-icon-button (click)="removeLeader(leader.id)">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
    <div class="my-3 text-xl">Add Leader</div>
    <div class="flex flex-col">
      <div class="form-field-label">
        Leader
      </div>
      <mat-form-field appearance="outline">
        <mat-select [formControl]="addLeaderFormControl">
          <mat-option>
            <ngx-mat-select-search
              placeholderLabel="User"
              noEntriesFoundLabel="User not found"
              [formControl]="leaderSearch"
            ></ngx-mat-select-search>
          </mat-option>
          <mat-option *ngFor="let user of possibleLeaders$ | async" [value]="user">{{ user.name }}</mat-option>
        </mat-select>
      </mat-form-field>
      <button type="button" mat-raised-button color="primary" (click)="addLeader(addLeaderFormControl.value)">
        Add {{ addLeaderFormControl.value?.name }}
      </button>
    </div>
  </div>
</ng-template>
